import React, { useState } from 'react';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import JobsForm from '../JobsPage/JobsForm';
import { FormattedMessage } from '../../util/reactIntl';
import StaticPage from '../StaticPage/StaticPage';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import VacancyBlock from './VacancyBlock.js';
import { submitApplication } from '../../ducks/ContactUs.duck';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import css from './JobsPageVacancy1.module.css';

const JobsPageVacancy1 = props => {
  const {
    submitApplicationError,
    submitApplicationInProgress,
    submitApplicationSuccess,
    onSubmitApplication,
  } = props;

  const [uploadedCoverLetter, setCoverLetter] = useState({});
  const [uploadedResume, setUploadedResume] = useState({});

  return (
    <StaticPage
      title="Jobs"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'JobsPageVacancy1',
        description: 'Jobs page',
        name: 'Jobs',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div className={css.staticPageWrapper}>
            <div className={css.mainColumnForJob}>
              <VacancyBlock />
            </div>
            <div className={css.formColumn}>
              <div className={css.jobDetailsWrapper}>
                <div className={css.price}>
                  $20.00 - $40.00
                  <span className={css.priceTip}> per hour</span>
                </div>
                <ul className={css.jobDetailsList}>
                  <li className={css.jobsDetailsItem}>Part-time or Temporary</li>
                  <li className={css.jobsDetailsItem}>Flexible schedule</li>
                  <li className={css.jobsDetailsItem}>Bonus pay</li>
                  <li className={css.jobsDetailsItem}>Work from home</li>
                </ul>
              </div>
              <div>
                <h2 className={css.formTitle}>
                  <FormattedMessage id="JobsForm.title" />
                </h2>
                <JobsForm
                  className={css.form}
                  onSubmit={values => {
                    onSubmitApplication({ ...values, files: [uploadedCoverLetter, uploadedResume], jobTitle: 'Florida Lead Teacher / State Manager' })
                      .then(() => {
                        setCoverLetter({});
                        setUploadedResume({});
                      })
                  }}
                  submitApplicationError={submitApplicationError}
                  uploadedCoverLetter={uploadedCoverLetter}
                  uploadedResume={uploadedResume}
                  setCoverLetter={setCoverLetter}
                  setUploadedResume={setUploadedResume}
                  submitInProgress={submitApplicationInProgress}
                  submitApplicationSuccess={submitApplicationSuccess}
                />
              </div>

              {/*<div className={css.jobEmailText}>*/}
              {/*  If you're interested in applying for this job, please email a cover letter and resume to <a href="mailto:jobs@allcourse.com" className={css.underline}>jobs@allcourse.com</a>*/}
              {/*</div>*/}
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

const mapStateToProps = state => {
  const {
    submitApplicationError,
    submitApplicationInProgress,
    submitApplicationSuccess,
  } = state.ContactUs;

  return {
    submitApplicationError,
    submitApplicationInProgress,
    submitApplicationSuccess,
  };
};

const mapDispatchToProps = dispatch => ({
  onSubmitApplication: ({ email, name, files, jobTitle }) => dispatch(submitApplication(email, name, files, jobTitle)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
)(JobsPageVacancy1);
